import PropTypes from 'prop-types';
import { noop } from '../../../utils/noop';
import { TooltipStyleStyles, TooltipTextStyles } from './Tooltip.style';

const TooltipText = ({ text, viewType }) => {
  return (
    <p className={`tooltipText ${viewType}`}>
      {text} <style jsx>{TooltipTextStyles}</style>
    </p>
  );
};

TooltipText.defaultProps = {
  viewType: 'default',
};

TooltipText.propTypes = {
  text: PropTypes.string.isRequired,
  viewType: PropTypes.oneOf(['fullWidth', 'default', 'medium']),
};

const Tooltip = ({
  tooltipContent,
  children,
  hasCaret,
  position,
  viewType,
  showArrow,
  tooltipContentRef,
  showWithoutHover,
  onCloseClick,
  showCrossButton,
}) => {
  const offsetLeft = tooltipContentRef?.current?.offsetLeft || '';
  return (
    <>
      <div className={`tooltipParent ${viewType}`}>
        {children}
        <div className={`tooltipContainer${showWithoutHover ? ' show-without-hover' : ''}  ${position}`}>
          {hasCaret && (
            <div
              style={
                offsetLeft
                  ? {
                      left: `${offsetLeft - 13.5}px`,
                      transform: 'translateX(0px)',
                    }
                  : {}
              }
              className={`caret ${position}`}
            />
          )}
          <div className="tooltipContent">{tooltipContent}</div>
          {showCrossButton && (
            <button
              type="button"
              className="cross-button"
              onClick={(e) => {
                onCloseClick();
                e.preventDefault();
                e.stopPropagation();
              }}
            />
          )}
        </div>
        {showArrow && <div className="pointer" />}
      </div>
      <style jsx>{TooltipStyleStyles}</style>
    </>
  );
};

Tooltip.defaultProps = {
  hasCaret: false,
  viewType: 'default',
  showArrow: false,
  tooltipContentRef: null,
  showWithoutHover: false,
  onCloseClick: noop,
  showCrossButton: false,
};

Tooltip.propTypes = {
  children: PropTypes.object.isRequired,
  tooltipContent: PropTypes.object.isRequired,
  tooltipContentRef: PropTypes.any,
  hasCaret: PropTypes.bool,
  position: PropTypes.oneOf([
    'left',
    'right',
    'bottom',
    'bottom-middle',
    'top',
    'top-left',
    'top-middle',
    'bottom-left',
    'bottom-left-1',
    'middle-1',
  ]).isRequired,
  viewType: PropTypes.oneOf(['fullWidth', 'default', 'medium', 'small']),
  showArrow: PropTypes.bool,
  showWithoutHover: PropTypes.bool,
  onCloseClick: PropTypes.func,
  showCrossButton: PropTypes.bool,
};

export { TooltipText, Tooltip };
